<template>
  <v-container fluid>
    <v-row class="mb-5">
      <v-col>
        <span class='font-16 font-w-700'>สรุปรายละเอียดโปรโมชัน ณ ร้าน Café Amazon  ประจำเดือนของเดือน{{dateStr}}</span>
        <DisplayBtn v-model="display"/>
      </v-col>
    </v-row>
    <v-card rounded outlined>
      <v-container fluid>
        <v-row class="text-center row-header">
          <v-col cols="7" sm="4">
            <v-row no-gutters>
              <v-col cols="12" sm="7">
                <v-container fluid fill-height class="pa-0">
                  <v-row no-gutters>
                    <v-col>โปรโมชัน</v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="5" class="d-none d-sm-block">
                <v-container fluid fill-height class="pa-0">
                  <v-row no-gutters>
                    <v-col>ระยะเวลา</v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="5" sm="8" class="promo-head2 pa-0" ref="promo-head2">
            <v-container fluid fill-height class="pa-0">
              <v-row no-gutters class="fill-height flex-nowrap"  :style="`flex: 0 0 ${daysInMonth * 50}px;`">
                <v-col
                  v-for="(day, i) in days"
                  :key="`hday-${i}`"
                  :class="`py-3 ${day.class}`">
                  {{day.dd}}<br>
                  <v-avatar
                    :color="day.isCur ? '#F1545B' : ''"
                    :class="day.isCur ? 'active' : ''"
                    size="24">{{day.D}}</v-avatar>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid class="pa-0">
        <v-row no-gutters class="content">
          <v-col cols="7" sm="4" class="promo-info pb-5" ref="promo-info">
            <template v-for="(color, name) in types">
              <v-container
                v-if="promotionsByType(name).length > 0"
                fluid
                :key="name">
                <v-row>
                  <v-col cols="12">
                    <h3 class="font-12 font-w-600 type-title">
                      <v-icon :color="color">mdi-square</v-icon>
                      {{name}}
                    </h3>
                  </v-col>
                </v-row>
                <v-row
                  v-for="promotion in promotionsByType(name)"
                  :key="promotion.Id"
                  :ref="`info-${promotion.Id}`">
                  <v-col cols="12" sm="7" class="no-border font-12 promo-title">{{promotion.PromotionName__c}}</v-col>
                  <v-col cols="12" sm="5" class="theme-color-two font-12">{{ dateRangeStr(promotion) }}</v-col>
                </v-row>
              </v-container>
            </template>
          </v-col>
          <v-col cols="5" sm="8" class="promo-gantt" ref="promo-gantt">
            <v-container fluid fill-height class="pa-0">
              <v-row no-gutters class="fill-height flex-nowrap" :style="`flex: 0 0 ${daysInMonth * 50}px;height:10000px;`">
                <v-col
                  v-for="(day, i) in days"
                  :key="`bar-bg-${i}`"
                  :class="day.class">
                  <v-container fluid fill-height/>
                </v-col>
                <template v-for="(color, name) in types">
                  <div
                    v-for="promotion in promotionsByType(name)"
                    :key="`bar-${promotion.Id}`"
                    :ref="`bar-${promotion.Id}`"
                    class="bar"
                    :style="{'background-color': color}"/>
                </template>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import DisplayBtn from '@/components/calendar/sub/DisplayBtn.vue'

export default {
  components: { DisplayBtn },
  data() {
    return {
      display: 'gantt',
    }
  },
  props: {
    promotions: { types: Array, require: true },
    form: { types: Object, require: true },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      this.calBar()
      this.$refs['promo-info'].addEventListener('scroll', this.onScroll);
      this.$refs['promo-gantt'].addEventListener('scroll', this.onScroll);
    })
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  watch:{
    display(newVal) {
      this.$emit('changeDisplay', newVal)
    },
    promotions() {
      this.$nextTick(this.calBar)
      this.$refs['promo-info'].scrollTop = 0
      this.$refs['promo-gantt'].scrollTop = 0
      this.$refs['promo-gantt'].scrollLeft = 0
      this.$refs['promo-head2'].scrollLeft = 0
    },
  },
  methods: {
    promotionsByType(type) {
      return this.promotions.filter(promotion => promotion.PromotionType__c == type)
    },
    dateRangeStr(promotion) {
      const start = this.dateShort(promotion.StartDate__c)

      if (!('EndDate__c' in promotion)) {
        return `${start}. เป็นต้นไป`
      }

      const end = this.dateShort(promotion.EndDate__c)

      return `${start} - ${end}`
    },
    dateShort(dateStr) {
      const m = moment(dateStr)
      return m.format('D MMM') + ' ' + (m.year()+543)%100
    },
    dateFirst(){
      return moment(new Date(this.form.year, this.form.month, 1))
    },
    onResize() {
      this.$nextTick(this.calBar)
    },
    onScroll() {
      this.$refs['promo-gantt'].scrollTop = this.$refs['promo-info'].scrollTop
      this.$refs['promo-head2'].scrollLeft = this.$refs['promo-gantt'].scrollLeft
    },
    calBar() {
      const first = this.dateFirst()
      const daysInMonth = first.daysInMonth()
      const last = this.dateFirst().date(daysInMonth)
      this.promotions.forEach(promotion => {
        const info = this.$refs[`info-${promotion.Id}`][0],
              bar = this.$refs[`bar-${promotion.Id}`][0]
        let top = 0, left = 0, right = 0

        top = info.offsetTop + 10

        const start = moment(promotion.StartDate__c)
        if (start >= first) {
          const diff = start.diff(first, 'day')
          left = Math.min((100 * diff / daysInMonth), 100)
          bar.style['border-bottom-left-radius']='5px'
          bar.style['border-top-left-radius']='5px'
          bar.style['margin-left']='2px'
        }else{
          bar.style['border-bottom-left-radius']='0px'
          bar.style['border-top-left-radius']='0px'
          bar.style['margin-left']='0px'
        }

        const end = 'EndDate__c' in promotion ? moment(promotion.EndDate__c) : false
        if (end && end <= last) {
          const diff = last.diff(end, 'day')
          right = Math.min((100 * diff / daysInMonth), 100)
          bar.style['border-bottom-right-radius']='5px'
          bar.style['border-top-right-radius']='5px'
          bar.style['margin-right']='2px'
        }else{
          bar.style['border-bottom-right-radius']='0px'
          bar.style['border-top-right-radius']='0px'
          bar.style['margin-right']='0px'
        }

        bar.style.top=`${top}px`
        bar.style.left=`${left}%`
        bar.style.right=`${right}%`
      });
    },
  },
  computed: {
    ...mapGetters({
      types: 'Calendar/getTypes',
    }),
    daysInMonth() {
      return this.dateFirst().daysInMonth()
    },
    dateStr() {
      const date = new Date(this.form.year, this.form.month)
      return moment(date).format('MMMM') + ' ' + (this.form.year + 543)
    },
    days() {
      const today = new Date()
      const date = this.dateFirst()
      const daysInMonth = date.daysInMonth()
      return [...Array(daysInMonth).keys()].map(day => {
        date.date(day+1)
        return {
          'dd': date.format('dd').replace('.', ''),
          'D': date.format('D'),
          'isCur': date.isSame(today, 'day'),
          'class': [0,6].includes(date.day()) ? 'weekend' : '',
        }
      })
    },
  }
};
</script>